import React from 'react';
import { observer } from 'mobx-react-lite';
import AtiNotifications from '@components/notifications';
import generatedHooks from '../../hooks/generatedHooks';
import * as styles from './Notifications.scss';

const { useUiStore } = generatedHooks;

const Notifications = () => {
  const {
    notificationsList,
    clearNotificationsList,
  } = useUiStore(store => store);

  return (
    <div className={styles.notificationsWrapper}>
      <AtiNotifications messages={notificationsList} onClose={clearNotificationsList} />
    </div>
  );
};

export default observer(Notifications);
